import { getFieldEmptyValue } from '.';
import { IString } from '../../../model';
import {
  FieldLinkageOpt,
  FieldOptAPIReqScenes,
  FieldOptSource,
  FieldType,
  IConfigField,
  IFieldOptAPI,
  ILinkageOptBySelect,
  IValue,
} from '../model';
import { mergeFieldConfigOptExtension } from './field-opt';

const getIndexKey = <T>(
  configFields: ReadonlyArray<IConfigField<T>>,
  key: string
) => {
  const targetIndex = configFields.findIndex((item) => item.key === key);
  if (targetIndex < 0) {
    return false;
  }
  return targetIndex;
};

// 目前仅支持以下几种关联
const ALLOW_RELATION_FIELD_TYPE = [
  FieldType.select,
  FieldType.select_multiple,
  FieldType.advanced_select,
  FieldType.advanced_select_multiple,
  FieldType.tree_select,
];

const mergeApiLinkage = (
  fieldOptExtension: IFieldOptAPI,
  linkage: ILinkageOptBySelect,
  key: string,
  value: any
) => {
  const merge = <T>(fieldObject: T | undefined) => {
    if (!fieldObject) {
      return;
    }

    let appendCustomObj = {};
    if (linkage.getCustomTargetReqValue) {
      appendCustomObj = linkage.getCustomTargetReqValue(key, value, linkage);
    }
    Object.assign(fieldObject, {
      [linkage.targetReqFieldName]: value,
      ...appendCustomObj,
    });
  };

  if (fieldOptExtension.api.kind === FieldOptAPIReqScenes.normal) {
    merge<Object | undefined>(fieldOptExtension.api.body);
    return true;
  }
  if (
    [FieldOptAPIReqScenes.proxy, FieldOptAPIReqScenes.proxyAll].includes(
      fieldOptExtension.api.kind
    )
  ) {
    merge<Object | undefined>(fieldOptExtension.api.transparentReqBody.query);
    return true;
  }
  return false;
};

const toFieldLinkageRow = <T>(
  item: FieldLinkageOpt,
  targetConfigField: IConfigField<T>,
  configFields: ReadonlyArray<IConfigField<T>>,
  key: string,
  value: any
) => {
  let isAllowMerge = false;
  const relationTargetKey = item.key;
  if (!targetConfigField.fieldOptExtension) {
    return null;
  }

  const targetIndex = getIndexKey(configFields, relationTargetKey);
  if (targetIndex === false) {
    return null;
  }

  // 处理Mock数据（暂不实现）
  // xxxxxxx

  // 处理API关联请求
  if (targetConfigField.fieldOptExtension.kind === FieldOptSource.api) {
    isAllowMerge = mergeApiLinkage(
      targetConfigField.fieldOptExtension,
      item,
      key,
      value
    );
  }

  return { isAllowMerge, targetIndex };
};

export const triggerFieldLinkageChanged = <T>(
  jsonConfigFields: IString<IConfigField<T>>,
  configFields: ReadonlyArray<IConfigField<T>>,
  key: string, // 触发者key
  value: any, // 触发者的值
  callback: (fieldConfig: IConfigField<T>, targetIndex: number) => void
) => {
  const configField = jsonConfigFields[key];
  if (!configField) {
    return;
  }

  // 关联多个字段
  const linkageOpt = configField.fieldLinkageOptExtension || [];
  if (!linkageOpt.length) {
    return;
  }

  linkageOpt.forEach((item) => {
    if (!ALLOW_RELATION_FIELD_TYPE.includes(item.kind)) {
      return null;
    }

    const targetConfigField = jsonConfigFields[item.key] || {};
    const rowRes = toFieldLinkageRow(
      item,
      targetConfigField,
      configFields,
      key,
      value
    );
    if (!rowRes) {
      return;
    }

    // 触发请求
    mergeFieldConfigOptExtension(
      targetConfigField,
      (fieldConfig: IConfigField<T>) => {
        callback(fieldConfig, rowRes.targetIndex);
      }
    );
  });
};

export const clearLinkageFieldValue = <T>(
  jsonConfigFields: IString<IConfigField<T>>,
  key: string
) => {
  const values: IString<IValue> = {};
  const configField = jsonConfigFields[key] || {};
  const linkageOpt = configField.fieldLinkageOptExtension || [];
  if (!linkageOpt.length) {
    return null;
  }
  linkageOpt.forEach((item) => {
    const linkage = jsonConfigFields[item.key];
    if (!linkage) {
      return;
    }
    const value = getFieldEmptyValue(linkage);
    if (value) {
      Object.assign(values, value);
    }
  });
  return values;
};
